import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function CompetitionHero() {
  return <section className="relative bg-ink pt-16 pb-24 overflow-hidden" data-id="element-806">
      <div className="absolute inset-0 opacity-40" data-id="element-807">
        <img src={SITE_IMAGES.competitionTeam} alt="Storm Taekwondo competition team on the podium" className="block w-full h-full object-cover object-top" data-id="element-808" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-809" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-810">
        <div className="max-w-2xl" data-id="element-811">
          <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-812">
            <Trophy className="w-4 h-4" data-id="element-813" />
            Elite Training
          </div>
          <h1 className="text-5xl md:text-6xl text-white mb-6 uppercase tracking-tight" data-id="element-814">
            Team Storm Competition Team
          </h1>
          <p className="text-xl text-off-white mb-8 leading-relaxed" data-id="element-815">
            For students ready to push their limits and compete at the highest
            levels. Led by experienced champions, Team Storm prepares athletes
            for local, state, and national Olympic-style Taekwondo tournaments.
          </p>
          <Link to="/ContactUs.html" className="btn-primary" data-id="element-816">
            Inquire About Tryouts
          </Link>
        </div>
      </div>
    </section>;
}